module.exports = __webpack_public_path__ + "b2d09649bcf10af9859aacafd406ad24.svg";